// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topic-editor-synonyms_input {
  min-height: 50vh;
  margin-top: 0.5rem;
  resize: none;
  font-size: 1.8rem;
}

.topic-editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.topic-editor-synonyms-close {
  position: absolute;
  right: 5rem;
  top: 5rem;
}

.topic-editor-synonyms_description {
  font-size: 1.6rem;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/app/nlp/topic-editor/synonyms-dialog/SynonymsDialog.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".topic-editor-synonyms_input {\r\n  min-height: 50vh;\r\n  margin-top: 0.5rem;\r\n  resize: none;\r\n  font-size: 1.8rem;\r\n}\r\n\r\n.topic-editor-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n\r\n.topic-editor-synonyms-close {\r\n  position: absolute;\r\n  right: 5rem;\r\n  top: 5rem;\r\n}\r\n\r\n.topic-editor-synonyms_description {\r\n  font-size: 1.6rem;\r\n  font-weight: bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
